/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ClientVersionDto } from '../models/ClientVersionDto';
import type { EntityModelResponseContainerClientVersionDto } from '../models/EntityModelResponseContainerClientVersionDto';
import type { PagedModelEntityModelClientVersionDto } from '../models/PagedModelEntityModelClientVersionDto';
import type { PagedResourcesAssemblerClientVersionDto } from '../models/PagedResourcesAssemblerClientVersionDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SystemClientVersionControllerService {
    /**
     * @returns PagedModelEntityModelClientVersionDto OK
     * @throws ApiError
     */
    public static list({
        assembler,
        startsWith,
        model,
        page,
        size = 100,
        sort,
    }: {
        assembler: PagedResourcesAssemblerClientVersionDto,
        startsWith?: string,
        model?: string,
        /**
         * Zero-based page index (0..N)
         */
        page?: number,
        /**
         * The size of the page to be returned
         */
        size?: number,
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>,
    }): CancelablePromise<PagedModelEntityModelClientVersionDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/system/compat/clients',
            query: {
                'startsWith': startsWith,
                'model': model,
                'page': page,
                'size': size,
                'sort': sort,
                'assembler': assembler,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerClientVersionDto OK
     * @throws ApiError
     */
    public static create({
        requestBody,
    }: {
        requestBody: ClientVersionDto,
    }): CancelablePromise<EntityModelResponseContainerClientVersionDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/system/compat/clients',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static delete({
        itemId,
    }: {
        itemId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/admin/system/compat/clients/{itemId}',
            path: {
                'itemId': itemId,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerClientVersionDto OK
     * @throws ApiError
     */
    public static read({
        itemId,
    }: {
        itemId: string,
    }): CancelablePromise<EntityModelResponseContainerClientVersionDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/system/compat/clients/{itemId}',
            path: {
                'itemId': itemId,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerClientVersionDto OK
     * @throws ApiError
     */
    public static update({
        itemId,
        requestBody,
    }: {
        itemId: string,
        requestBody: ClientVersionDto,
    }): CancelablePromise<EntityModelResponseContainerClientVersionDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/admin/system/compat/clients/{itemId}',
            path: {
                'itemId': itemId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
